import pluralize from 'pluralize';

type SelectedItem = {
  id: number;
  name: string;
};

type FormatSelectedItemsOptions<T extends SelectedItem> = {
  items: T[];
  itemTypeName: string;
  maxItemsToShow?: number;
};

/**
 * Formats selected items for copilot context with consistent patterns:
 * - Shows limited number of items with overflow indicator
 * - Formats each item as "name (idKey: id)"
 * - Handles empty state
 */
export default function formatSelectedItemsContext<T extends SelectedItem>({
  items,
  itemTypeName,
  maxItemsToShow = 10,
}: FormatSelectedItemsOptions<T>): string {
  if (!items || items.length === 0) {
    const itemTypePlural = pluralize(itemTypeName);

    return `No selected ${itemTypePlural}`;
  }

  const itemsToShow = items.slice(-maxItemsToShow);
  const itemNames = itemsToShow.map((item) => `${item.name} (ID: ${item.id})`);
  const remainingCount = items.length - itemsToShow.length;

  const baseMessage = `Selected ${pluralize(itemTypeName, items.length)}: ${itemNames.join(', ')}`;

  if (remainingCount > 0) {
    return `${baseMessage} and ${remainingCount} more...`;
  }

  return baseMessage;
}

